import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageIntro } from "@/components/kit/PageIntro";
import { Phases } from "@/components/blocks/Phases";
import { CtaBand } from "@/components/kit/CtaBand";
import { Reveal } from "@/components/site/Motion";
import { JsonLd, serviceSchema, usePageMeta } from "@/components/site/Seo";
import { AUDIENCES, PROGRAMME_PATH, SITE } from "@/lib/content";

function Visual() {
  return (
    <div className="relative mx-auto max-w-[420px]">
      <div className="arch relative aspect-[4/5] overflow-hidden">
        <img src="/images/meal.jpg" alt="Balanced, colourful nourishing meal bowl" className="h-full w-full scale-105 object-cover" />
      </div>
      <div className="absolute -bottom-5 left-0 rounded-2xl bg-cream px-5 py-4 text-forest shadow-xl" data-testid="programme-price-chip">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.2em] text-gold-ink">{SITE.days} days</p>
        <p className="font-display text-4xl">{SITE.price}<span className="text-base text-charcoal-soft"> /month</span></p>
      </div>
    </div>
  );
}

export default function Programme() {
  usePageMeta("Healthy Active Lifestyle Programme | ₹7,500/month, 120 days", "The 120-Day Wellness Journey: a coached Healthy Active Lifestyle Programme by wellness coach Sony Mathew. ₹7,500 per month. Free 20-minute consultation.");
  return (
    <div data-testid="programme-page">
      <JsonLd id="service" data={serviceSchema("Healthy Active Lifestyle Programme", "120-day wellness and nutrition coaching programme.", PROGRAMME_PATH, "7500")} />
      <PageIntro
        testId="programme-hero"
        eyebrow="Our programme · Healthy Active Lifestyle"
        lines={["The 120-Day", <em key="w" className="text-gold-soft">Wellness Journey</em>]}
        intro="A structured, supportive programme designed to help you build healthy habits and achieve lasting results. Wellness coach, not dietitian: for medical conditions this is nutrition support alongside your doctor's treatment."
        script="Real food. Real habits. Real results."
        aside={<Visual />}
      />
      <Phases />
      <section data-testid="programme-audiences" className="bg-forest-deep py-24 text-cream sm:py-28">
        <div className="wrap">
          <p className="eyebrow-dark">Shaped for you</p>
          <div className="mt-8 divide-y divide-cream/10 border-y border-cream/10">
            {AUDIENCES.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.04}>
                <Link to={`/${a.slug}`} data-testid={`programme-audience-${a.slug}`} className="group flex items-center justify-between gap-6 py-6 transition-[padding] duration-500 hover:pl-3">
                  <span className="font-display text-3xl sm:text-5xl">{a.title}</span>
                  <ArrowUpRight className="h-6 w-6 shrink-0 text-gold-soft transition-transform duration-500 group-hover:rotate-45" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CtaBand testId="programme-cta" />
    </div>
  );
}
